import { render, staticRenderFns } from "./BadgeExpirationWarning.vue?vue&type=template&id=633805c8&scoped=true"
import script from "./BadgeExpirationWarning.vue?vue&type=script&lang=js"
export * from "./BadgeExpirationWarning.vue?vue&type=script&lang=js"
import style0 from "./BadgeExpirationWarning.vue?vue&type=style&index=0&id=633805c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633805c8",
  null
  
)

export default component.exports